import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Table } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setDoplnky } from '../redux/actions/prvkyActions';
import RecommTable from '../comp/RecommTable';
import TextOrMdash from '../comp/TextOrMdash';
import DisplayFoto from '../comp/DisplayFoto';
import DisplayDokument from '../comp/DisplayDokument';
import URLEndPointBE from '../comp/URLEndPointBE';
import DeEscapeTxt from '../comp/DeEscapeTxt';
import IDokument from '../ts/IDokument';
import IDisplayDokument from '../ts/IDisplayDokument';

function ViewingDoplnek() {
    const { keycloak, initialized } = useKeycloak();
    const FetchSetDoplnky = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/doplnky`)
            .catch((error) => {
                console.log("Err", error)
            });
        //return response.data;
        dispatch(setDoplnky(response.data))
    }
    let { doplnekId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
            //potential succ from insertion/edit redirect
            const {state} = useLocation();
            console.log(state)

    let doplnky = useSelector((state: any) => state.allPrvky.doplnky);
    //console.log("doplnky")
    //console.log(doplnky)
    let doplnek_doplnekId = doplnky.find((dopl: any) => (dopl.id===doplnekId))  
    console.log("doplnek_doplnekId")
    console.log(doplnek_doplnekId)
    /*if (doplnky.length == 0)
    {
        console.log("empty condition")
        //const doplnkyF = FetchDoplnky();
        Promise.resolve(FetchDoplnky()).then((result) => {
            console.log("result")
            console.log(result)
            doplnky = null;
            doplnky=result;
            doplnek_doplnekId = doplnky.find((dopl: any) => (dopl.id===doplnekId))
        })
    }*/

    
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    const klasifikace = useSelector((state: any) => state.miscDicts.klasifikace);
    console.log("displaying doplnek")
    console.log(doplnek_doplnekId)
    
    const DeleteDoplnek = () => {
        console.log("DeleteDoplnek() " + doplnekId);
        axios.delete(URLEndPointBE+`/doplnek/`+doplnekId, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
        .then((response) => {
            console.log(response);
            //if response.data success - go /listing/doplnky
            console.log(response.data);
            console.log(response.data.success);
            if(response.data.success==1) {
                console.log("redirecting")
                setTimeout(function() {
                    navigate('/listing/doplnky', {state: {succ: true, type: 'SMAZANI', item: 'DOPLNKU'}});
                }, 1500);
            }
            else {
                console.log ("err")
            }
        })
        .catch(function(error) {
            console.log(error);
        })
    }

    useEffect(() => {
        dispatch(setMenuSelected("doplnky"));
        FetchSetDoplnky();

        if (doplnekId && doplnekId !== "")
            console.log("doplnekId && doplnekId !== \"\"")
        return () => {
            //why?
        };
    }, [doplnekId])

    return (
        <Container>
            {/*/@ts-ignore*/}
            {(state?.succ)?<Row className={"succRow"}>
            {/*/@ts-ignore*/}
            <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
            </Row>:<></>}
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'>{DeEscapeTxt(doplnek_doplnekId?.kod)}</th>
                        <th><span>{DeEscapeTxt(doplnek_doplnekId?.nazev)}</span>
                            <span> &nbsp;
                            {keycloak.authenticated && ( <span>
                            <Link className="navRemoveUnderscoreInLinkA" to={"/doplnky/edit/"+doplnek_doplnekId?.id}>
                                <span className="katBtnStyle printHide" >EDITOVAT</span>
                            </Link> &nbsp;
                            <span className="katBtnStyle ptHover printHide" onClick={() => {DeleteDoplnek()}}>SMAZAT</span>
                            </span>)}
                            </span> 
                            <span className="print" onClick={()=>window.print()}>&nbsp;&#9113;&nbsp;</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td align='center'>{(typeof (doplnek_doplnekId?.foto) !== 'undefined' && doplnek_doplnekId?.foto != null)
                        ? <span style={{display:"inline-block", width:"340px"}}><div>{doplnek_doplnekId?.foto.map((foto: any) => <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></span>
                        : <td>&mdash;</td>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null)
                            ? <TextOrMdash text={viditelnost.find((vid: any) => vid.key===doplnek_doplnekId?.viditelnost)?.value} />
                            : <div>&mdash;</div>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOPLNKY POUZITI</th>
                        <td>{(typeof (doplnek_doplnekId?.doplnkyPouziti) !== 'undefined' && doplnek_doplnekId?.doplnkyPouziti != null)
                            ? <RecommTable recommendations={doplnek_doplnekId?.doplnkyPouziti} />
                            : <div>&mdash;</div>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>KLASIFIKACE</th>
                        <td>{(typeof (klasifikace) !== 'undefined' && klasifikace != null)
                        ? <TextOrMdash text={klasifikace.find((klasif: any)=>klasif.key===doplnek_doplnekId?.klasifikace)?.value} />
                        : <div>&mdash;</div>}</td>
                        {/*<td><TextOrMdash text={doplnek_doplnekId.klasifikace}/></td>*/}
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td><TextOrMdash text={DeEscapeTxt(doplnek_doplnekId?.popis)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE</th>
                        <td><TextOrMdash text={DeEscapeTxt(doplnek_doplnekId?.modifikace)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POZNÁMKA</th>
                        <td><TextOrMdash text={DeEscapeTxt(doplnek_doplnekId?.poznamka)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td><TextOrMdash text={DeEscapeTxt(doplnek_doplnekId?.dostupnost)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOKUMENTY</th>
                        {/*expand this*/}
                        <td>{(typeof (doplnek_doplnekId?.dokumenty) !== 'undefined' && doplnek_doplnekId?.dokumenty!=null)
                            ? <span>{doplnek_doplnekId?.dokumenty.map((dokument: any) => <DisplayDokument dokumentId={dokument.dokumentId}/> )}</span>
                            : <span>&mdash;</span>}</td>
                    </tr>
                </tbody>
            </Table>
        </Container>
    )
}
export default ViewingDoplnek